module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown">\n    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n        <div class="selected-icon-preview pull-left"></div>\n        <span class="caret"></span>\n    </button>\n\n    <div class="dropdown-menu">\n        <div class="row">\n            <div class="col-md-12">\n                <input type="text" placeholder="Search..." class="icon-search-input" />\n            </div>\n        </div>\n        <div class="all-groups-hidden-message hidden row">\n            <div class="col-md-12">\n                No results\n            </div>\n        </div>\n        <div class="icons-group-container"></div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/button/IconsSelectionView.tpl
// module id = 1762
// module chunks = 0